export function convertFormValuesToFormData(filterDataValue: any) {
  const formData = new FormData();
  Object.keys(filterDataValue).map((ele: string) => {
    if (filterDataValue[ele] != null && filterDataValue[ele] != "") {
      formData.set(ele, filterDataValue[ele]);
    }
  });
  return formData;
}
